import { useCultureCode } from '@mews-commander/core';
import { getCurrencyCultureInfo, getCurrencyLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';
import { SymbolPosition, SymbolSpacing } from '@mews/framework';

interface CurrencyFormat {
    symbol: string;
    symbolPosition: SymbolPosition;
    symbolSpacing: SymbolSpacing;
    precision: number;
    decimalSeparator: string;
    groupSeparator: string;
}

export const useCurrencyFormat = (currencyCode: string): CurrencyFormat => {
    const cultureCode = useCultureCode();

    const { decimalSeparator, groupSeparator } = useCommanderSelector((state) =>
        getCurrencyCultureInfo(state, { cultureCode })
    );
    const { symbol, symbolPosition, symbolSpacing, precision } = useCommanderSelector((state) =>
        getCurrencyLocalizationInfo(state, { currencyCode, cultureCode })
    );

    return {
        symbol,
        symbolPosition,
        symbolSpacing,
        precision,
        decimalSeparator,
        groupSeparator,
    };
};
